<template>
  <v-page>
    <v-card class="elevation-4 text-xs-center pa-4">
      <h1 class="display-2 text--primary">Oops</h1>
      <p>This page does not exist</p>
      <v-btn outlined color="primary" to="/home">Back to Home</v-btn>
    </v-card>
  </v-page>
</template>

<script>
import VPage from '../layouts/Minimal.vue'

export default {
  name: 'NotFound',
  components: {
    VPage
  }
}
</script>
